export const findServerEdges = [
  {
    id: "60.150.25.71-81.119.95.47",
    source: "60.150.25.71",
    target: "81.119.95.47",
    type: "straight",
  },
  {
    id: "81.119.95.47-104.169.110.92",
    source: "104.169.110.92",
    target: "81.119.95.47",
    type: "straight",
  },
  {
    id: "34.239.245.172-99.133.116.181",
    source: "34.239.245.172",
    target: "99.133.116.181",
    type: "straight",
  },

  {
    id: "5.10.40.25-203.212.60.217",
    source: "5.10.40.25",
    target: "203.212.60.217",
    type: "straight",
  },
  {
    id: "51.251.205.152-155.177.229.194",
    source: "155.177.229.194",
    target: "51.251.205.152",
    type: "straight",
  },
  {
    id: "155.177.229.194-199.38.67.227",
    source: "155.177.229.194",
    target: "199.38.67.227",
    type: "straight",
  },

  {
    id: "34.239.245.172-60.40.118.216",
    source: "60.40.118.216",
    target: "34.239.245.172",
    type: "straight",
  },
  {
    id: "60.40.118.216-81.119.95.47",
    source: "60.40.118.216",
    target: "81.119.95.47",
    type: "straight",
  },
  {
    id: "60.40.118.216-155.177.229.194",
    source: "60.40.118.216",
    target: "155.177.229.194",
    type: "straight",
  },
  {
    id: "60.40.118.216-203.212.60.217",
    source: "60.40.118.216",
    target: "203.212.60.217",
    type: "straight",
  },

  {
    id: "81.119.95.47-203.212.60.217",
    source: "81.119.95.47",
    target: "203.212.60.217",
    type: "straight",
  },
  {
    id: "34.239.245.172-81.119.95.47",
    source: "81.119.95.47",
    target: "34.239.245.172",
    type: "straight",
  },
  {
    id: "34.239.245.172-155.177.229.194",
    source: "155.177.229.194",
    target: "34.239.245.172",
    type: "straight",
  },
  {
    id: "155.177.229.194-203.212.60.217",
    source: "155.177.229.194",
    target: "203.212.60.217",
    type: "straight",
  },
];
